'use strict';

/**
 * Mobile language drawer: anchors use href for locale URLs; drawer behaviour lives in drawer.js.
 */
module.exports = function () {};
